import { useRef, useLayoutEffect } from 'react';

// 숫자와 일반 문자를 모두 입력할 수 있는 칸 (예: 소비자단가·공급가액·수량).
// 값이 '순수 숫자'이면 천단위 구분기호(,)를 자동으로 붙여 보여주고, 문자가 섞이면 입력한 그대로 보여준다.
// 저장되는 값(onValueChange)은 숫자일 때 콤마가 없는 문자열이라 기존 숫자 판별(isBundleNum)·계산에 그대로 쓸 수 있다.

const PLAIN_NUMBER = /^-?\d+(\.\d*)?$/;

// 표시용: 순수 숫자면 정수부에 천단위 구분기호, 그 외(문자·빈 값)는 그대로
export const fmtNumericDisplay = (raw) => {
  const s = String(raw ?? '');
  const t = s.trim();
  if (!PLAIN_NUMBER.test(t)) return s;
  const neg = t.startsWith('-');
  const [intPart, ...rest] = (neg ? t.slice(1) : t).split('.');
  const digits = intPart.replace(/^0+(?=\d)/, ''); // 선행 0 제거 ('0' 자체는 유지)
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (neg ? '-' : '') + grouped + (rest.length ? `.${rest.join('.')}` : '');
};

// 입력값 → 저장값: 콤마를 제거했을 때 순수 숫자이면 콤마 없는 숫자 문자열, 아니면 입력한 그대로(텍스트)
export const parseNumericInput = (typed) => {
  const stripped = String(typed ?? '').replace(/,/g, '');
  return PLAIN_NUMBER.test(stripped) ? stripped : String(typed ?? '');
};

export default function SmartNumInput({ value, onValueChange, ...props }) {
  const ref = useRef(null);
  const caret = useRef(null); // 커서 앞의 '콤마 제외 글자 수' — 값이 다시 그려진 뒤 같은 위치로 복원
  const display = fmtNumericDisplay(value);

  useLayoutEffect(() => {
    const el = ref.current;
    if (caret.current == null || !el || document.activeElement !== el) { caret.current = null; return; }
    let seen = 0, pos = 0;
    while (pos < display.length && seen < caret.current) { if (display[pos] !== ',') seen++; pos++; }
    el.setSelectionRange(pos, pos);
    caret.current = null;
  });

  return (
    <input {...props} ref={ref} value={display}
      onChange={(e) => {
        const el = e.target;
        caret.current = el.value.slice(0, el.selectionStart ?? el.value.length).replace(/,/g, '').length;
        onValueChange(parseNumericInput(el.value));
      }} />
  );
}
